<ng-template #content let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h6 class="modal-title">{{'TITLE.TITLE_MANUAL_ASSIGNMENT' | translate}} <span *ngIf="JobData"> ({{JobData.DisplayCallNo}} | <i class="fas fa-map-marker-alt"></i> {{JobData.LocationName}})</span></h6>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body container-fluid manualAssign">
        <form name="frm">
            <div *ngIf="Mode == _JobOperationActions.ReAssign">
                <ErrorSummary [ErrorList]="FormErrors"></ErrorSummary>
                <div class="row form-group">
                    <div class="col-2 pr-0">
                        <label class="col-form-label" translate>LBL.REASON</label>
                    </div>
                    <div class="col-5 ellipsis pl-0">
                        <select class="custom-select" id="ClosedReasonCode" [(ngModel)]="RequestModel.ClosedReasonCode" name="ClosedReasonCode">
                            <option [value]="0" translate>CMB_DEF.CMB_DEF_SELECT_REASON</option>
                            <option *ngFor="let row of masterService.GetReasonTypes(PropertyId, 'REASR')" [value]="row.ID">{{row.Description}}</option>
                        </select>
                    </div>
                    <div class="col pl-0 d-flex">
                        <div class="mr-2">
                            <label class="col-form-label" translate>LBL.REMARKS</label>
                        </div>
                        <div class="col pr-0">
                            <RemarksPopupTrigger [(Model)]="RequestModel.LastActionRemarks">
                                <textarea class="form-control" rows="1" [(ngModel)]="RequestModel.LastActionRemarks" name="Remarks" id="Remarks" placeholder="{{'PH.PH_ENTER_REMARK' | translate}}"></textarea>
                            </RemarksPopupTrigger>
                        </div>
                    </div>
                </div>                
            </div>
            <div class="row form-group">
                <div class="col-2 pr-0">
                    <label translate class="col-form-label">LBL.CALL_DESC</label>
                </div>
                <div class="col-5 ellipsis pl-0">
                    <label class="col-form-label font-weight-normal ">{{CallDescription?.Description}}</label>
                </div>
                <div class="col pl-0 d-flex ellipsis" *ngIf="JobData && JobData.AssignToName">
                    <div class="mr-2">
                        <label class="col-form-label" translate>LBL.CURRENT_STAFF</label>
                    </div>
                    <div class="ellipsis">
                        <label class="col-form-label font-weight-normal ">{{JobData.AssignToName}}</label>
                    </div>
                </div>
            </div>            
            <div class="form-group d-flex justify-content-between">
                <div class="">
                    <label class="col-form-label" translate>LBL.SEARCH_BY_NAME</label>
                </div>
                <div class="selectBox">
                    <input type="text" class="form-control " name="Keyword" [(ngModel)]="Keyword" (input)="onKeyword($event.target.value)" />
                </div>
                <div class="px-1 text-right">
                    <label class="col-form-label" translate>LBL.FILTER</label>
                </div>
                <div class="selectBox">
                    <select class="custom-select " [(ngModel)]="Filter" name="Filter" (change)="onFilter()">
                        <option [value]="1" translate>ENTITIES.ENTITIES_ALL</option>
                        <option [value]="2" translate>ENTITIES.ENTITIES_WITH_REQ_SKILLS_ASSIGNED_TO_SECTION</option>
                        <option [value]="3" translate>ENTITIES.ENTITIES_WITHOUT_REQ_SKILLS_ASSIGNED_TO_SECTION</option>
                        <option [value]="4" translate>ENTITIES.ENTITIES_WITH_REQ_SKILLS_NOT_ASSIGNED_TO_SECTION</option>
                    </select>
                </div>
                <div class="px-1 text-right">
                    <label class="col-form-label" translate>LBL.SORT</label>
                </div>
                <div class="selectBox">
                    <select class="custom-select" [(ngModel)]="SortBy" name="SortBy" (change)="onSort()">
                        <option [value]="1" translate>CMB_DEF.CMB_VAL_NAME</option>
                        <option [value]="2" translate>CMB_DEF.CMB_VAL_NOOFCALLS</option>
                    </select>
                </div>
            </div>
        </form>

        <div class="grdTable manualAssign">
            <div class="row no-gutters grdTableHeader">
                <div class="col-1 grdHead"></div>
                <div class="col-7 grdHead"><span translate>LBL.FRM_NAME</span></div>
                <div class="col-2 grdHead text-center"><span translate>LBL.OPEN_CALLS</span></div>
                <div class="col-2 grdHead"></div>
            </div>
            <div class="grdBodyScroll-Virtual" #scrollingBlock> 
                <virtual-scroller #scroll [items]="StaffList" style="height:100%" [parentScroll]="scrollingBlock.nativeElement">
                    <div *ngFor="let row of scroll.viewPortItems" class="row no-gutters grdRow">
                        <div class="col-1 grdCol text-center">
                            <div [class]="row.IsLoggedIn ? 'text-success': ''"><i class="fas fa-user fa-fw"></i></div>
                        </div>
                        <div class="col-7 grdCol">{{row.Description}}</div>
                        <div class="col-2 grdCol text-center"><span *ngIf="row.AllOpenCalls <= 0">{{row.AllOpenCalls == null ? 0 : row.AllOpenCalls}}</span> <button class="btn btn-link p-0" *ngIf="row.AllOpenCalls > 0" (click)="staffJobList.Open(row)">{{row.AllOpenCalls}}</button></div>
                        <div class="col-2 grdCol"><label *ngIf="row.StaffId == SelectedStaffId" translate>LBL.SELECTED</label> <button *ngIf="row.StaffId != SelectedStaffId" class="btn btn-link p-0" (click)="onStaffSelect(row.StaffId); onStaffSelected(SelectedStaffId)" translate>BTN.BTN_SELECT</button></div>
                    </div>
                </virtual-scroller>
                
            </div>
        </div>
    </div>

    <div class="modal-footer" *ngIf="RequestModel && RequestModel.Operation == _JobOperationActions.ReAssign">
        <button class="btn btn-primary" type="button" (click)="onSubmit()" [disabled]="IsSubmitting" translate>BTN.BTN_OK</button>
        <button class="btn btn-secondary" type="button" (click)="c('')" translate>BTN.BTN_CANCEL</button>
    </div>
</ng-template>

<StaffJobList #staffJobList></StaffJobList>
